module.exports = __webpack_public_path__ + "img/table.0ea61f89.svg";